// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
// import success from "/success.png"
// import firebase from "../firebase/firebaseConfig";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logEvent } from "../ga";
// import { useHistory } from "react-router-dom";

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [userId, setUserId] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [hasRedirected, setHasRedirected] = useState(false);
  // useEffect(() => {
  //   logEvent("User", "Created an Account'", "Signup Button");
  // }, []);

  // useEffect(() => {
  //   console.log("hii");

  //   const storedId = localStorage.getItem("organizationId");
  //   const storedEmail = localStorage.getItem("organizationEmail");

  //   if (storedId && storedEmail) {
  //     navigate("/paymentSuccess");
  //     setHasRedirected(true);
  //   }

  //   // Prevent going back after initial redirect
  //   if (hasRedirected) {
  //     const disableBack = () => {
  //       window.history.pushState(null, null, window.location.href);
  //       window.addEventListener("popstate", (event) => {
  //         window.history.pushState(null, null, window.location.href);
  //       });
  //     };

  //     disableBack();

  //     return () => {
  //       window.removeEventListener("popstate", disableBack);
  //     };
  //   }
  // }, [location, navigate]);
  // const history = useHistory();

  useEffect(() => {
    // Handle navigation blocking or redirection on mount
    const handleBeforeUnload = (event) => {
      // Preventing default behavior to block navigation
      event.preventDefault();
      // Set a message for the dialog box (some browsers might ignore this)
      event.returnValue = "";
    };

    // Add event listener for beforeunload
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      // Cleanup the event listener on component unmount
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [navigate]);

  useEffect(() => {
    const handlePopState = () => {
      navigate("/login", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    // firebase.auth().onAuthStateChanged((user) => {
    //   if (user) {
    //     setUserId(user.uid)
    //     const userRef = firebase.database().ref("users/" + user.uid);
    //     userRef.on('value', (snapshot) => {
    //       const user = snapshot.val();
    //       if (user) {
    //         setSessionId(user.subscription.sessionId || "")
    //       }
    //     })
    //   }
    // })
  }, [userId, sessionId]);

  console.log(sessionId);

  const handlePaymentSuccess = () => {
    fetch("http://localhost:5000/api/v1/payment-success", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ sessionId: sessionId, email: userId }),
    })
      .then((res) => {
        if (res.ok) return res.json();
        return res.json().then((json) => Promise.reject(json));
      })
      .then((data) => {
        console.log(data.message);
        navigate("/");
      })
      .catch((e) => {
        console.log(e.error);
      });
  };
  // const handleSignupClick = () => {
  //   logEvent("User", "Created an Account'", "Signup Button");
  // };

  return (
    // <div className='m-0 p-0'>
    //   <div className='w-full min-h-[80vh] flex flex-col justify-center items-center'>
    //     <div className='my-10 text-green-600 text-2xl mx-auto flex flex-col justify-center items-center'>
    //       <img src="/success.png" alt="" width={220} height={220} />
    //       <h3 className='text-4xl pt-20 lg:pt-0 font-bold text-center text-slate-700'>
    //         Payment Successful
    //       </h3>
    //       <button onClick={() => handlePaymentSuccess()}
    //         className='w-40 uppercase bg-[#009C96] text-white text-xl my-16 px-2 py-2 rounded'
    //       >
    //         Proceed
    //       </button>
    //     </div>
    //   </div>
    // </div>
    //   <div class="bg-gray-100 h-screen">
    //     <div class="bg-white p-6  md:mx-auto">
    //       <svg viewBox="0 0 24 24" class="text-green-600 w-16 h-16 mx-auto my-6">
    //           <path fill="currentColor"
    //               d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z">
    //           </path>
    //       </svg>
    //       <div class="text-center">
    //           <h3 class="md:text-2xl text-base text-gray-900 font-semibold text-center">Payment Done!</h3>
    //           <p class="text-gray-600 my-2">Thank you for completing your secure online payment.</p>
    //           <p> Have a great day!  </p>
    //           <div class="py-10 text-center">
    //               <a href="#" class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3">
    //                   GO BACK
    //              </a>
    //           </div>
    //       </div>
    //   </div>
    // </div>
    <div class="bg-gray-100 min-h-screen flex items-center justify-center">
      <div class="bg-white p-6 md:mx-auto max-w-md w-full">
        <svg viewBox="0 0 24 24" class="text-green-600 w-12 h-12 mx-auto my-6">
          <path
            fill="currentColor"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
          ></path>
        </svg>
        <div class="text-center">
          <h3 class="md:text-2xl text-base text-gray-900 font-semibold text-center">
            Payment Done!
          </h3>
          <p class="text-gray-600 my-2">
            Thank You For Completing Your Secure Online Payment.
          </p>
          <p> Have A Great Day! </p>
          <div class="py-10 text-center">
            <Link
              to="/login"
              class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3"
              // onClick={handleSignupClick}
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
